module.exports = __webpack_public_path__ + "img/banner.5c3425e5.jpg";